import { render, staticRenderFns } from "./DeleteInvoicesNewModal.vue?vue&type=template&id=387adb16&"
import script from "./DeleteInvoicesNewModal.vue?vue&type=script&lang=js&"
export * from "./DeleteInvoicesNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports